import { Injectable } from '@angular/core';
import { SCREEN_SIZE } from '@lib/core';
import { BehaviorSubject, distinctUntilChanged, Observable, Subject } from 'rxjs';

@Injectable()
export class DeviceService {
  private currentSize: SCREEN_SIZE = null;

  get onResize$(): Observable<SCREEN_SIZE> {
    return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
  }

  private resizeSubject: Subject<SCREEN_SIZE>;

  constructor() {
    this.resizeSubject = new BehaviorSubject(this.currentSize);
  }

  onResize(size: SCREEN_SIZE) {
    if (this.currentSize !== size) {
      this.currentSize = size;
      this.resizeSubject.next(size);
    }
  }

  getDevice(): string {
    return this.currentSize === SCREEN_SIZE.mobile ? 'mobile' : this.currentSize === SCREEN_SIZE.tablet ? 'tablet' : 'desktop';
  }
}
